module.exports = __webpack_public_path__ + "static/media/dashboard_placeholder.eab82cdc.png";